module.exports = __webpack_public_path__ + "media/customizations/montaneranch/logo-689d847db190cab3c78a619f9ffa5d8e.png";